import { find } from 'rambda'

import type { TreeFlatOption } from '../../types'

const getParentPath = (list: TreeFlatOption[], data: TreeFlatOption, path: string, visited = new Set<string>([data.value])): string => {
    if (!data.parentId || visited.has(data.parentId)) {
        return path
    }
    const parent = find(item => item.value === data.parentId, list)
    if (!parent) {
        return path
    }
    const parentPath = `${parent.label}/${path}`
    visited.add(parent.value)
    return getParentPath(list, parent, parentPath, visited)
}

export const getOptionWithPath = (list: TreeFlatOption[]) => {
    return list.map(item => {
        const labelPath = getParentPath(list, item, item.label)
        return {
            ...item,
            labelPath
        }
    })
}
